import { Component, OnInit, Input } from '@angular/core';
import { AppComponent} from '../../app.component';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { AlertService } from '../../alertpopup/_alert';
export class UserMaster {
  ID: any;
  UserName: string;
  Email: string;
  Mobile: any;
}

export class EscalationUserDataV2{
  ID: any;
  LevelID:any;
  Days : any;
  Interval : any;
  EmailEmployee = [];
  recEnable:any;
  
}

export class EscalationDataV2 {
  ReportID:any;
  FeatureDs : string;
  UserID:any;
  UserName: string;
 
  EDList: EscalationUserDataV2[];
  UserData: UserMaster[];
  recEnable: any;
}

@Component({
    selector: 'app-escalation-user-entry',
    templateUrl: './escalation-user-entry.component.html',
    styleUrls: ['./escalation-user-entry.component.css'],
    standalone: false
})
export class EscalationUserEntryComponent implements OnInit {
  url: string;
  EscalationEntry: FormGroup;
  EscalationData: EscalationDataV2;
  ReportID: any;
  UserID: any;
  NonUser:any;
  UserMasterDetail: UserMaster[];
  pageurl: string;
  postString:string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    // this.EscalationEntry = this.formBuilder.group({
    // });
    const formGroup = {};
    formGroup['Employee'] = new FormControl("");
    formGroup['ReportID'] = new FormControl("");
    formGroup['UserID'] = new FormControl("");
    formGroup['NonUser'] = new FormControl("");
    this.EscalationEntry = new FormGroup(formGroup);
    this.EscalationData = new EscalationDataV2();

    //this.EscalationData.EDList = new EscalationUserDataV2[];

    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.ReportID = pagehead[2];
    this.UserID = pagehead[3];
    
    this.LoadData();
  }

  LoadData()
  {
    this.http.get(this.url + 'AlertNotificationDetail/LoadEscalation?ReportID=' + this.ReportID + "&UserID=" + this.UserID)
    .subscribe( (data) => {

        if (data == null || data.toString() == "[]") {
        }
        else {
          this.EscalationData = JSON.parse(data.toString());
          this.UserMasterDetail = this.EscalationData.UserData;

           const formGroup = {};
           formGroup['Employee'] = new FormControl("");
           formGroup['ReportID'] = new FormControl("");
           formGroup['UserID'] = new FormControl("");
           formGroup['NonUser'] = new FormControl("");
           // Build Dynamic Form Control Name
           this.EscalationData.EDList.forEach(ed => {
             formGroup['Users_' + ed.LevelID] = new FormControl("");
             formGroup['Interval_' + ed.LevelID] = new FormControl("");
             formGroup['Day_' + ed.LevelID] = new FormControl("");
             formGroup['ID_' + ed.LevelID] = new FormControl("");
             formGroup['LevelID_' + ed.LevelID] = new FormControl("");
             formGroup['recEnable_' + ed.LevelID] = new FormControl("");
             
             this.EscalationEntry = new FormGroup(formGroup);
           });

          // Patch Values
          for (var val of this.EscalationData.EDList) {
            (this.EscalationEntry.get(String('ID_' + val.LevelID)) as FormControl).patchValue(val.ID);
            (this.EscalationEntry.get(String('LevelID_' + val.LevelID)) as FormControl).patchValue(val.LevelID);
            if(val.EmailEmployee != null && val.EmailEmployee.toString().split(',').length > 0)
            {
              val.EmailEmployee = val.EmailEmployee.toString().split(',').map(Number);
              (this.EscalationEntry.get(String('Users_' + val.LevelID)) as FormControl).patchValue(val.EmailEmployee);
            }
            (this.EscalationEntry.get(String('Day_' + val.LevelID)) as FormControl).patchValue(val.Days);
            (this.EscalationEntry.get(String('Interval_' + val.LevelID)) as FormControl).patchValue(val.Interval);
            (this.EscalationEntry.get(String('recEnable_' + val.LevelID)) as FormControl).patchValue(val.recEnable);
          }
        }
      },
      (error) => {
       }
    );
  }
  onEscalationSubmit(Data)
  {
    if(Data.Employee < 1)
    {
      this.alertService.warn('Please select employee', this.options);
      return;
    }
    this.postString="";
    for (var val of this.EscalationData.EDList) {
      this.postString += (this.postString != ""? "|":"");
      this.postString += (this.EscalationEntry.get(String('ID_' + val.LevelID)) as FormControl).value + '~';
      this.postString += (this.EscalationEntry.get(String('LevelID_' + val.LevelID)) as FormControl).value + '~';
      if((this.EscalationEntry.get(String('Users_' + val.LevelID)) as FormControl).value != null)
        this.postString += (this.EscalationEntry.get(String('Users_' + val.LevelID)) as FormControl).value + '~';
      else
        this.postString += '~';
      this.postString += (this.EscalationEntry.get(String('Day_' + val.LevelID)) as FormControl).value + '~';
      this.postString += (this.EscalationEntry.get(String('Interval_' + val.LevelID)) as FormControl).value + '~';
      //(this.EscalationEntry.get(String('recEnable_' + val.LevelID)) as FormControl).patchValue(val.recEnable);
    }

    let postData={
      ReportID : this.ReportID,
      UserID : (this.EscalationEntry.get(String('Employee')) as FormControl).value,
      NonUser:Data.NonUser,
      EmailSetting: this.postString
    };


    this.http.post(this.url + 'AlertNotificationDetail/UpdateEscalation', postData) .subscribe( (data) => {
      if (data == null) {
        this.alertService.error('An Error Occurred', true);
      } else {
        this.alertService.success(data.toString() , this.options);
      }
     }
   );
  }

}
